@if (companies.length > 1) {
  <p-select
    optionLabel="name"
    class="p-dropdown-custom slim"
    [options]="companies"
    [placeholder]="'$select$' | translate"
    [(ngModel)]="selectedCompany"
    (onClick)="$event.stopPropagation()"
    (onChange)="changeCompany()" />
}
